import { Model } from '@/models/Model';
import { Size } from '@/models/Size';
import { Brand } from '@/models/Brand';
import { SupplierSize } from '@/models/SupplierSize';

export class SupplierSizeDeviation extends Model{
  protected $name: string = 'SupplierSizeDeviation';

  protected $endpoint: string = '/supplier-size-deviations';

  protected $fillable: string[] = [
    'size_id',
    'brand_id',
    'supplier_size_id',
  ];

  protected $includes: SpecificSupplierSizeIncludeType[] = [];

  protected filters: SpecificSupplierSizeFilterInterface = {};

  public id?: string;
  public brand?: Brand;
  public brand_id?: string;
  public size?: Size;
  public size_id?: string;
  public supplier_size?: SupplierSize;
  public supplier_size_id?: string;

  public filter(filters: (keyof SpecificSupplierSizeFilterInterface) | SpecificSupplierSizeFilterInterface, value?: any) {
    return super.filter.call(this, filters, value);
  }

  public include(includes: SpecificSupplierSizeIncludeType | SpecificSupplierSizeIncludeType[]): this {
    return super.include.call(this, includes);
  }

  public removeFilter(key: keyof SpecificSupplierSizeFilterInterface): this {
    return super.removeFilter.call(this, key);
  }
}


export type SpecificSupplierSizeIncludeType = 'brand' | 'size' | 'supplier_size';

export interface SpecificSupplierSizeFilterInterface {
  brand?: string;
};
